<template>
  <div>
    <B2CTrendChart
      :months="trend.months"
      :series="chartSeries"
      empty-text="Sin datos para el rango elegido"
    />
    <p v-if="hasReconstructed" class="caption grey--text text--darken-1 mt-1 mb-0">
      Línea punteada: meses reconstruidos desde las fechas de las membresías. Subestiman:
      {{ deactivatedLabel }} membresías desactivadas sin fecha de término quedan fuera.
      Las membresías disponibles no tienen historia antes de {{ firstSnapshotLabel }}: desde ahí se
      guarda una foto diaria y cada mes cierra con su última foto.
    </p>
  </div>
</template>

<script>
import B2CTrendChart, { TREND_COLORS, TREND_DASHES } from './B2CTrendChart.vue';
import { buildTrendSeries, formatInt } from '@/utils/pet-protection.utils';

export default {
  name: 'PetProtectionTrendChart',
  components: { B2CTrendChart },
  props: {
    // [{ period, activePets, potentialPets, source }]
    series: { type: Array, default: () => [] },
    // { deactivatedWithoutEndDate, firstSnapshotPeriod }
    reconstructionNote: { type: Object, default: () => ({}) },
    // Which lines to draw: 'both' | 'active' | 'available'
    lines: { type: String, default: 'both' }
  },
  computed: {
    trend() {
      return buildTrendSeries(this.series);
    },
    hasReconstructed() {
      return this.series.some((p) => p.source === 'reconstructed');
    },
    showActive() {
      return this.lines !== 'available';
    },
    showAvailable() {
      return this.lines !== 'active';
    },
    chartSeries() {
      const datasets = [];
      if (this.showActive && this.hasReconstructed) {
        datasets.push({
          // Same metric as the solid line; the dashed style and the note below explain it.
          label: 'Mascotas activas',
          data: this.trend.reconstructed,
          color: TREND_COLORS.muted,
          dash: TREND_DASHES.short,
          hideInLegend: true
        });
      }
      if (this.showActive) datasets.push({
        label: 'Mascotas activas',
        data: this.trend.recorded,
        color: TREND_COLORS.primary,
        dash: []
      });
      if (this.showAvailable) datasets.push({
        label: 'Membresías disponibles',
        data: this.trend.potential,
        color: TREND_COLORS.text,
        dash: TREND_DASHES.long
      });
      return datasets;
    },
    deactivatedLabel() {
      return formatInt(this.reconstructionNote.deactivatedWithoutEndDate || 0);
    },
    firstSnapshotLabel() {
      return this.reconstructionNote.firstSnapshotPeriod || 'este mes';
    }
  }
};
</script>
